import { Box, Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import React from 'react'

export const useStyles = makeStyles({
  root: {
    '& .MuiSvgIcon-root': {
      fontSize: 18
    }
  },
  text: {
    marginTop: 2,
    marginLeft: 4,
    textTransform: 'capitalize'
  }
})
const IconTag = ({ icon, text, className, ...props }) => {
  const classes = useStyles(props)
  const isFeaturedPill = className?.includes('featuredPill')

  return (
    <Box
      display={isFeaturedPill ? 'inline-block' : 'flex'}
      alignItems='center'
      flexWrap='nowrap'
      className={`${classes.root} ${className || ''}`}
    >
      {icon}
      <Typography
        variant='body1'
        noWrap
        align='left'
        className={classes.text}
        sx={{ marginLeft: icon ? 1 : 0 }}
      >
        {text}
        {/* {content?.type ?? <Skeleton width='80%' />} */}
      </Typography>
    </Box>
  )
}

export default IconTag
